
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wan-3-0-ai-video-generator",
      function () {
        return require("private-next-pages/wan-3-0-ai-video-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wan-3-0-ai-video-generator"])
      });
    }
  